/**
 * "Install ZIvapp".
 *
 * The link screen used to offer a Windows download pointing at /download —
 * a route that does not exist, for an application that does not exist. This
 * replaces it with the install that is real: the PWA.
 *
 * Three different situations, and only one of them is a button:
 *
 *   Chrome / Edge   fires beforeinstallprompt, so installing is one tap
 *   iOS Safari      never fires it; the user must use Share > Add to Home
 *                   Screen, so the banner explains that instead
 *   already installed, or a browser that cannot
 *                   nothing is shown — an install button that does nothing
 *                   when pressed is worse than no button
 */

import { useEffect, useState } from 'react'
import {
  canInstall, promptInstall, isStandalone, isIOS
} from '../../pwa/installPrompt.js'
import './InstallBanner.css'

export default function InstallBanner () {
  const [available, setAvailable] = useState(canInstall)
  const [installed, setInstalled] = useState(isStandalone)

  useEffect(() => {
    const onAvailable = () => setAvailable(true)
    const onInstalled = () => { setInstalled(true); setAvailable(false) }

    // installPrompt.js captures beforeinstallprompt at module load, which
    // happens before this mounts — hence the initial read above as well as
    // these listeners.
    window.addEventListener('ziv:install-available', onAvailable)
    window.addEventListener('ziv:installed', onInstalled)
    return () => {
      window.removeEventListener('ziv:install-available', onAvailable)
      window.removeEventListener('ziv:installed', onInstalled)
    }
  }, [])

  if (installed) return null

  const ios = isIOS()
  if (!available && !ios) return null

  return (
    <section className="ib">
      <span className="ib__art" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <rect x="6" y="2.5" width="12" height="19" rx="2.6"
            stroke="currentColor" strokeWidth="1.8" />
          <path d="M10.4 18.6h3.2" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" />
          <path d="M12 7v6m0 0 2.4-2.4M12 13l-2.4-2.4" stroke="currentColor"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>

      <div className="ib__text">
        <h2>Install ZIvapp</h2>
        {ios ? (
          <p>
            Tap <strong>Share</strong>, then <strong>Add to Home Screen</strong> to
            use ZIvapp like an app.
          </p>
        ) : (
          <p>Add it to your device for a full-screen app that works offline.</p>
        )}
      </div>

      {/* No button on iOS: Safari gives no way to trigger the install, so
          one here could only lie about what it does. */}
      {!ios && (
        <button type="button" className="ib__go" onClick={promptInstall}>
          Install
        </button>
      )}
    </section>
  )
}
